export default __webpack_public_path__ + "static/media/basic-pin-large-3.65851ce1.png";